export default __webpack_public_path__ + "img/88c1ce7e7ba479bc4f6ff4bd80dca6bb.png";